// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3CVRZ","legacyBtn":"MutateMid_legacyBtn__7u8kf"};